import React, { useState, useEffect, useRef } from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";

function getCords(position: string) {
  let rawPosition = position.replace("(", "");
  rawPosition = rawPosition.replace(")", "");
  rawPosition = rawPosition.replace(" ", "");
  const pos = rawPosition.split(",");
  return {
    lat: parseFloat(pos[0]),
    lng: parseFloat(pos[1]),
  };
}

function MapMarker({ distributor }: any) {
  const center = getCords(distributor.pozycja);
  const [showInfoWindows, setShowInfoWindow] = useState(false);

  const wrappRef = useRef<any>(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        wrappRef.current &&
        !wrappRef.current.containerElement.contains(event.target)
      ) {
        setShowInfoWindow(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrappRef]);

  return (
    <>
      <Marker
        icon={
          distributor.name === "Firmowy punkt sprzedaży KAMAL"
            ? "https://kamal.pl/wp-content/themes/responsive-mobile/images/map-marker.png"
            : "https://kamal.pl/wp-content/themes/responsive-mobile/images/marker-red1.png"
        }
        position={center}
        onClick={() => setShowInfoWindow(true)}
        zIndex={distributor.name === "Firmowy punkt sprzedaży KAMAL" ? 999 : 1}
      />
      {showInfoWindows && (
        <InfoWindow
          onCloseClick={() => setShowInfoWindow(false)}
          position={center}
          ref={wrappRef}
        >
          <div>
            <strong>{distributor.name}</strong>
            <br />
            <strong>tel:</strong> {distributor.telefon}
            <br />
            <strong>e-mail:</strong> {distributor.email}
            <br />
            <span
              dangerouslySetInnerHTML={{
                __html:
                  distributor.miejscowosc +
                  " " +
                  distributor.kod +
                  " " +
                  distributor.adres,
              }}
            />
          </div>
        </InfoWindow>
      )}
    </>
  );
}

export default MapMarker;
